import { YoutubeIcon } from './YoutubeIcon';

/**
 * author: Google
 * id 0A078909-90AF-41F5-8E76-CAB565D49AAA
 * name youtube
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/youtube.svg
 * tags
 * - Brand / Logo 
 * - Social Media 
 */
export const YoutubePlayIcon = YoutubeIcon;
export default YoutubePlayIcon